import {useDispatch, useSelector} from 'react-redux'
import {AppRootState} from '../model/config'
import {Group} from '../model/favorites'
import {setFavoriteGroups} from '../store/appsSlice'

const useFavoriteGroups = (): [Group[], (newGroups: Group[]) => void] => {
  const favoriteGroups = useSelector(
    (state: AppRootState) => state.app.favoriteGroups
  )
  const dispatch = useDispatch()
  const setter = (newGroups: Group[]) => {
    dispatch(setFavoriteGroups(newGroups))
  }

  return [favoriteGroups, setter]
}

export default useFavoriteGroups
